module.exports = __webpack_public_path__ + "img/head-banner5.4add1d35.jpg";